import React, { useEffect, useState } from 'react';
import { MdOutlineCancel, MdEdit, MdSave } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import { Button } from '..';
import { useStateContext } from '../../contexts/ContextProvider';
import { RxAvatar } from "react-icons/rx";
import AuthServices from '../../actions/actions';
import { fetchUser } from '../../utils/fetchUser';
import Select from 'react-select';
import { getComunas } from "../../services/Comunas";
import { getUserProfile, updateProfileUsuario } from '../../services/UsuarioSucursal';
import { Toaster,toast } from 'react-hot-toast';

const initialState = {
  empresa: '',
  rut: '',
  nombre: '',
  direccion: '',
  numero: '',
  telefono: '',
  email: '',
  idComuna: '',
  nombreComuna: '',
  nombreCiudad: '',
  contacto: '',
  lat: 0,
  lng: 0
};

const UserProfile = () => {
  const { currentColor, isClicked, setIsClicked } = useStateContext();
  const userInfo = fetchUser();
  const navigate = useNavigate();
  const [formData, setFormData] = useState(initialState);
  const [editMode, setEditMode] = useState(false);
  const [comunaData, setComunaData] = useState([]);
  const [originalData, setOriginalData] = useState(initialState);
  
  // Estilos para campos según modo
  const inputClass = `text-[13px] border border-gray-300 p-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400 transition-colors ${
    editMode ? 'bg-white text-gray-800' : 'bg-gray-50 text-gray-600'
  }`;
  
  const labelClass = "text-xs font-medium text-gray-600 mb-1";

  useEffect(() => {
    // Simulación de carga de datos del usuario
    const fetchData = async () => {
      const misComunas = await getComunas();
      setComunaData(misComunas);
      // Llamar a rutina que recupera datos según
      const miData = await getUserProfile();
      
      // console.log(' Datos Profile ' + JSON.stringify(miData));

      setFormData(miData);
      setOriginalData(miData);
    };
    
    fetchData();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Aquí iría la lógica para guardar los cambios
    try{
        const dataProfile = {
          _id: userInfo.usuario,
          rol: userInfo.rol,
          nombre: formData.nombre,
          direccion : formData.direccion,
          numero : formData.numero,
          telefono : formData.telefono,
          email : formData.email,
          idComuna : formData.idComuna,
          lat : formData.lat,
          lng : formData.lng
        };
        await updateProfileUsuario(dataProfile);
        setEditMode(false);
     } catch (error) {
      console.log("Problemas al editar Perfil, contacte a soporte" + error);
      toast.error("Problemas al editar Perfil, contacte a soporte");
    }
  };

  const toggleEditMode = () => {
    if (editMode) {
      // Si estábamos en modo edición y cancelamos, revertimos los cambios
      setFormData(originalData);
    }
    setEditMode(!editMode);
  };

  const comunaOptions = comunaData.map((item) => ({
    value: item._id,
    label: `${item.codigoComuna} - ${item.nombreComuna}`,
  }));

  return (
    <div className="fixed inset-0 bg-black bg-opacity-30 flex items-start justify-center z-50 overflow-y-auto py-4 md:py-16">
      <div className="nav-item bg-white dark:bg-[#42464D] p-6 rounded-xl w-full max-w-md shadow-2xl mt-16 mx-4 max-h-[90vh] overflow-y-auto md:max-h-none md:overflow-visible">
        <div className="flex justify-between items-center mb-4">
          <div className="flex items-center gap-3">
            <RxAvatar className="text-3xl text-blue-500" />
            <div>
              <p className="font-bold text-lg text-gray-800 dark:text-gray-200">Mi Perfil</p>
              <p className="text-xs text-gray-500">Administra tu información personal</p>
            </div>
          </div>
          <button
            type="button"
            onClick={() => setIsClicked(!isClicked.UserProfile)}
            className="text-gray-500 hover:text-gray-700 transition-colors"
          >
            <MdOutlineCancel className="text-2xl" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="flex justify-end">
            <button
              type="button"
              onClick={toggleEditMode}
              className={`flex items-center gap-1 px-3 py-2 rounded-lg font-medium text-sm transition-colors ${
                editMode 
                  ? 'bg-gray-200 text-gray-700 hover:bg-gray-300' 
                  : 'bg-blue-500 text-white hover:bg-blue-600'
              }`}
            >
              {editMode ? (
                <>
                  <MdOutlineCancel className="text-base" /> Cancelar
                </>
              ) : (
                <>
                  <MdEdit className="text-base" /> Editar
                </>
              )}
            </button>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="flex flex-col">
              <label className={labelClass}>RUT</label>
              <input
                className={inputClass}
                type="text"
                name="rut"
                value={formData.rut}
                disabled={true} // RUT no se puede editar
                onChange={handleChange}
              />
            </div>
            
            <div className="flex flex-col">
              <label className={labelClass}>Nombre</label>
              <input
                className={inputClass}
                type="text"
                name="nombre"
                value={formData.nombre}
                disabled={!editMode}
                onChange={handleChange}
                required
              />
            </div>
            
            <div className="flex flex-col md:col-span-2">
              <label className={labelClass}>Dirección</label>
              <input
                className={inputClass}
                type="text"
                name="direccion"
                value={formData.direccion}
                disabled={!editMode}
                onChange={handleChange}
              />
            </div>
            
            <div className="flex flex-col">
              <label className={labelClass}>Número</label>
              <input
                className={inputClass}
                type="text"
                name="numero"
                value={formData.numero}
                disabled={!editMode}
                onChange={handleChange}
              />
            </div>
            
            <div className="flex flex-col">
              <label className={labelClass}>Comuna</label>
              <Select
                options={comunaOptions}
                value={comunaOptions.find((option) => option.value === formData.idComuna)}
                onChange={(selectedOption) => {
                  if (selectedOption) {
                    const comunaSeleccionada = comunaData.find(c => c._id === selectedOption.value);
                    setFormData((prev) => ({
                      ...prev,
                      idComuna: selectedOption.value,
                      nombreCiudad: comunaSeleccionada?.nombreCiudad || '',
                    }));
                  }
                }}
                className="text-xs"
                placeholder="Buscar ..."
                isClearable
                isDisabled={!editMode}
                styles={{
                  control: (base) => ({
                    ...base,
                    borderColor: '#d1d5db',
                    minHeight: '36px',
                    fontSize: '13px',
                    borderRadius: '8px',
                    backgroundColor: editMode ? '#fff' : '#f9fafb',
                    boxShadow: 'none',
                    '&:hover': {
                      borderColor: '#93c5fd'
                    }
                  }),
                  option: (base) => ({
                    ...base,
                    fontSize: '13px'
                  })
                }}
              />
            </div>
            
            <div className="flex flex-col">
              <label className={labelClass}>Ciudad</label>
              <input
                className={inputClass}
                type="text"
                name="nombreCiudad"
                value={formData.nombreCiudad}
                disabled={true} // Se llena automáticamente
                onChange={handleChange}
              />
            </div>
            
            <div className="flex flex-col">
              <label className={labelClass}>Teléfono</label>
              <input
                className={inputClass}
                type="tel"
                placeholder="Teléfono"
                name="telefono"
                value={formData.telefono}
                disabled={!editMode}
                onChange={handleChange}
              />
            </div>
            
            <div className="flex flex-col">
              <label className={labelClass}>Email</label>
              <input
                className={inputClass}
                type="email"
                placeholder="email"
                name="email"
                value={formData.email}
                disabled={!editMode}
                onChange={handleChange}
              />
            </div>
          </div>
          
          {editMode && (
            <div className="pt-4">
              <Button
                type="button"
                color="white"
                bgColor={currentColor}
                text="Guardar Cambios"
                borderRadius="10px"
                width="full"
                icon={<MdSave className="text-lg" />}
                handleClick={handleSubmit}
              />
            </div>
          )}
        </form>
        
        <div className="mt-6 pt-4 border-t border-gray-200">
          <Button
            color="white"
            bgColor="#ef4444"
            text="Cerrar Sesión"
            borderRadius="10px"
            width="full"
            handleClick={() => {
              setIsClicked(!isClicked.UserProfile);
              AuthServices.logout();
              navigate('/login');
            }}
          />
        </div>
        
      </div>
      <Toaster  position="top-right"  toastOptions={{  style: {  zIndex: 9999,  },  }} />      
    </div>
  );
};

export default UserProfile;